import angular from 'angular';
import datePicker from './datePicker';

export default angular
  .module('components.datePicker', [])
  .component('datePicker', datePicker).name;
